import { createContext } from "react";

export const SportContext = createContext({
  sports: [],
  sport: {},
});
